
import React from 'react'
import {formatMs} from '../utils/time'

const ResultadoDetailTablaRankings = (props) => (
  <div className={'resultado__tabla-container'}>
    {(props.rankingsResultados && props.rankingsResultados.length) ? (
      <table className={'resultado__tabla'}>
        <thead>
          <tr>
            <th>Ranking</th>
            <th>Pos</th>
            <th>Tiempo</th>
            <th>P.Sexo</th>
            <th>P.Cat.</th>
          </tr>
        </thead>
        <tbody>
          {props.rankingsResultados.map(r => (
            <tr key={r.id}>
              <td>{r.ranking_header}</td>
              <td>{r.puesto}</td>
              <td>{formatMs(r.valor)}</td>
              <td>{r.sexo}-{r.puesto_sexo}</td>
              {r.categoria_codigo ? (
                <td>{r.categoria_codigo}-{r.puesto_categoria}</td>
              ) : (
                <td>{r.puesto_categoria}</td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <h4>No hay datos</h4>
    )}
  </div>
)

export default ResultadoDetailTablaRankings



// WEBPACK FOOTER //
// ./src/components/ResultadoDetailTablaRankings.js